//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export abstract class BaseClient {
  transformResult(_url: string, _response: Response, processor: (_response: Response) => Promise<void | any>) {
    const { status } = _response;
    if (status === INTERGTRATION_API_ERROR_CDOE) {
      _response
        .clone()
        .text()
        .then((_responseText) => {
          const result = JSON.parse(_responseText) as IntegrationApiErrorRespponse;
          document.dispatchEvent(
            new CustomEvent<IntegrationApiErrorRespponse>(INTERGTRATION_API_ERROR_NOTIFICATION, { detail: result }),
          );

          return _responseText;
        })
        .catch((error) => {
          console.error(error);
        });
    }

    return processor(_response);
  }
}

export interface IEmailNotificationClient {

    sendAccessDeniedNotification(command: CreateAccessDeniedEmailNotificationCommand): Promise<void>;

    sendExceptionNotification(command: CreateExceptionEmailNotificationCommand): Promise<void>;

    sendCustomNotification(command: CreateCustomEmailNotificationCommand): Promise<void>;
}

export class EmailNotificationClient extends BaseClient implements IEmailNotificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    sendAccessDeniedNotification(command: CreateAccessDeniedEmailNotificationCommand): Promise<void> {
        let url_ = this.baseUrl + "/shared-api/emailnotification/access-denied";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendAccessDeniedNotification(_response));
        });
    }

    protected processSendAccessDeniedNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendExceptionNotification(command: CreateExceptionEmailNotificationCommand): Promise<void> {
        let url_ = this.baseUrl + "/shared-api/emailnotification/exception";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendExceptionNotification(_response));
        });
    }

    protected processSendExceptionNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendCustomNotification(command: CreateCustomEmailNotificationCommand): Promise<void> {
        let url_ = this.baseUrl + "/shared-api/emailnotification/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendCustomNotification(_response));
        });
    }

    protected processSendCustomNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEncodedDataClient {

    getLatestEncodingVersion(projectId: string | null, source: string | null | undefined): Promise<EncodingVersionDto>;

    getEncodedVersions(projectId: string | null, source: string | null | undefined): Promise<EncodingVersionDto[]>;

    generateDataDictionary(projectId: string | null, source: string | null | undefined, includeNonComplete: boolean | undefined, stackedVariableName: string | null | undefined, useDataLakeApi: boolean | undefined, isStacked: boolean | undefined): Promise<EncodingTriggeredHistoryDto>;

    getEncodingTriggeredHistory(projectId: string | null): Promise<EncodingTriggeredHistoryDto>;

    deleteEncodingTriggeredHistory(projectId: string | null): Promise<void>;

    updateStatus(command: UpdateEncodingTriggeredHistoryCommand): Promise<EncodingTriggeredHistoryDto>;

    addStatus(command: AddEncodingTriggeredHistoryCommand): Promise<EncodingTriggeredHistoryDto>;

    getEncodingTriggeringStatus(projectSource: string | null | undefined, token: string | null | undefined, createdAt: string | undefined, useDataLakeApi: boolean | undefined, isStacked: boolean | undefined): Promise<EncodingTriggeringStatuses>;

    getEncodingTriggeringStatusDetails(projectSource: string | null | undefined, token: string | null | undefined, createdAt: string | undefined, useDataLakeApi: boolean | undefined, isStacked: boolean | undefined): Promise<TriggeredEncodingStatusDto>;

    downloadEncodingVersionChangesFile(projectId: string | null | undefined, encodingVersion: string | null | undefined, changeType: ChangeTypes | undefined, source: string | null | undefined): Promise<FileResponse>;
}

export class EncodedDataClient extends BaseClient implements IEncodedDataClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLatestEncodingVersion(projectId: string | null, source: string | null | undefined): Promise<EncodingVersionDto> {
        let url_ = this.baseUrl + "/shared-api/encodeddata/{projectId}/latestversion?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (source !== undefined && source !== null)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLatestEncodingVersion(_response));
        });
    }

    protected processGetLatestEncodingVersion(response: Response): Promise<EncodingVersionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingVersionDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingVersionDto>(null as any);
    }

    getEncodedVersions(projectId: string | null, source: string | null | undefined): Promise<EncodingVersionDto[]> {
        let url_ = this.baseUrl + "/shared-api/encodeddata/{projectId}/versions?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (source !== undefined && source !== null)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEncodedVersions(_response));
        });
    }

    protected processGetEncodedVersions(response: Response): Promise<EncodingVersionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingVersionDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingVersionDto[]>(null as any);
    }

    generateDataDictionary(projectId: string | null, source: string | null | undefined, includeNonComplete: boolean | undefined, stackedVariableName: string | null | undefined, useDataLakeApi: boolean | undefined, isStacked: boolean | undefined): Promise<EncodingTriggeredHistoryDto> {
        let url_ = this.baseUrl + "/shared-api/encodeddata/{projectId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (source !== undefined && source !== null)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (includeNonComplete === null)
            throw new Error("The parameter 'includeNonComplete' cannot be null.");
        else if (includeNonComplete !== undefined)
            url_ += "includeNonComplete=" + encodeURIComponent("" + includeNonComplete) + "&";
        if (stackedVariableName !== undefined && stackedVariableName !== null)
            url_ += "stackedVariableName=" + encodeURIComponent("" + stackedVariableName) + "&";
        if (useDataLakeApi === null)
            throw new Error("The parameter 'useDataLakeApi' cannot be null.");
        else if (useDataLakeApi !== undefined)
            url_ += "useDataLakeApi=" + encodeURIComponent("" + useDataLakeApi) + "&";
        if (isStacked === null)
            throw new Error("The parameter 'isStacked' cannot be null.");
        else if (isStacked !== undefined)
            url_ += "isStacked=" + encodeURIComponent("" + isStacked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateDataDictionary(_response));
        });
    }

    protected processGenerateDataDictionary(response: Response): Promise<EncodingTriggeredHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingTriggeredHistoryDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingTriggeredHistoryDto>(null as any);
    }

    getEncodingTriggeredHistory(projectId: string | null): Promise<EncodingTriggeredHistoryDto> {
        let url_ = this.baseUrl + "/shared-api/encodeddata/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEncodingTriggeredHistory(_response));
        });
    }

    protected processGetEncodingTriggeredHistory(response: Response): Promise<EncodingTriggeredHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingTriggeredHistoryDto;
            return result200;
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingTriggeredHistoryDto>(null as any);
    }

    deleteEncodingTriggeredHistory(projectId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/shared-api/encodeddata/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteEncodingTriggeredHistory(_response));
        });
    }

    protected processDeleteEncodingTriggeredHistory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateStatus(command: UpdateEncodingTriggeredHistoryCommand): Promise<EncodingTriggeredHistoryDto> {
        let url_ = this.baseUrl + "/shared-api/encodeddata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateStatus(_response));
        });
    }

    protected processUpdateStatus(response: Response): Promise<EncodingTriggeredHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingTriggeredHistoryDto;
            return result200;
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingTriggeredHistoryDto>(null as any);
    }

    addStatus(command: AddEncodingTriggeredHistoryCommand): Promise<EncodingTriggeredHistoryDto> {
        let url_ = this.baseUrl + "/shared-api/encodeddata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddStatus(_response));
        });
    }

    protected processAddStatus(response: Response): Promise<EncodingTriggeredHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingTriggeredHistoryDto;
            return result200;
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingTriggeredHistoryDto>(null as any);
    }

    getEncodingTriggeringStatus(projectSource: string | null | undefined, token: string | null | undefined, createdAt: string | undefined, useDataLakeApi: boolean | undefined, isStacked: boolean | undefined): Promise<EncodingTriggeringStatuses> {
        let url_ = this.baseUrl + "/shared-api/encodeddata/status?";
        if (projectSource !== undefined && projectSource !== null)
            url_ += "ProjectSource=" + encodeURIComponent("" + projectSource) + "&";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (createdAt === null)
            throw new Error("The parameter 'createdAt' cannot be null.");
        else if (createdAt !== undefined)
            url_ += "CreatedAt=" + encodeURIComponent("" + createdAt) + "&";
        if (useDataLakeApi === null)
            throw new Error("The parameter 'useDataLakeApi' cannot be null.");
        else if (useDataLakeApi !== undefined)
            url_ += "UseDataLakeApi=" + encodeURIComponent("" + useDataLakeApi) + "&";
        if (isStacked === null)
            throw new Error("The parameter 'isStacked' cannot be null.");
        else if (isStacked !== undefined)
            url_ += "IsStacked=" + encodeURIComponent("" + isStacked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEncodingTriggeringStatus(_response));
        });
    }

    protected processGetEncodingTriggeringStatus(response: Response): Promise<EncodingTriggeringStatuses> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingTriggeringStatuses;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingTriggeringStatuses>(null as any);
    }

    getEncodingTriggeringStatusDetails(projectSource: string | null | undefined, token: string | null | undefined, createdAt: string | undefined, useDataLakeApi: boolean | undefined, isStacked: boolean | undefined): Promise<TriggeredEncodingStatusDto> {
        let url_ = this.baseUrl + "/shared-api/encodeddata/status-details?";
        if (projectSource !== undefined && projectSource !== null)
            url_ += "ProjectSource=" + encodeURIComponent("" + projectSource) + "&";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (createdAt === null)
            throw new Error("The parameter 'createdAt' cannot be null.");
        else if (createdAt !== undefined)
            url_ += "CreatedAt=" + encodeURIComponent("" + createdAt) + "&";
        if (useDataLakeApi === null)
            throw new Error("The parameter 'useDataLakeApi' cannot be null.");
        else if (useDataLakeApi !== undefined)
            url_ += "UseDataLakeApi=" + encodeURIComponent("" + useDataLakeApi) + "&";
        if (isStacked === null)
            throw new Error("The parameter 'isStacked' cannot be null.");
        else if (isStacked !== undefined)
            url_ += "IsStacked=" + encodeURIComponent("" + isStacked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEncodingTriggeringStatusDetails(_response));
        });
    }

    protected processGetEncodingTriggeringStatusDetails(response: Response): Promise<TriggeredEncodingStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TriggeredEncodingStatusDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TriggeredEncodingStatusDto>(null as any);
    }

    downloadEncodingVersionChangesFile(projectId: string | null | undefined, encodingVersion: string | null | undefined, changeType: ChangeTypes | undefined, source: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/shared-api/encodeddata/encoding-version-changes-file?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (encodingVersion !== undefined && encodingVersion !== null)
            url_ += "EncodingVersion=" + encodeURIComponent("" + encodingVersion) + "&";
        if (changeType === null)
            throw new Error("The parameter 'changeType' cannot be null.");
        else if (changeType !== undefined)
            url_ += "ChangeType=" + encodeURIComponent("" + changeType) + "&";
        if (source !== undefined && source !== null)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadEncodingVersionChangesFile(_response));
        });
    }

    protected processDownloadEncodingVersionChangesFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IFilesClient {

    downloadFileByUrl(command: DownloadFileByUrlCommand): Promise<FileResponse>;
}

export class FilesClient extends BaseClient implements IFilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    downloadFileByUrl(command: DownloadFileByUrlCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/shared-api/files/by-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFileByUrl(_response));
        });
    }

    protected processDownloadFileByUrl(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IProjectsClient {

    getAllProjects(): Promise<ShortProjectDto[]>;
}

export class ProjectsClient extends BaseClient implements IProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllProjects(): Promise<ShortProjectDto[]> {
        let url_ = this.baseUrl + "/shared-api/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllProjects(_response));
        });
    }

    protected processGetAllProjects(response: Response): Promise<ShortProjectDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShortProjectDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShortProjectDto[]>(null as any);
    }
}

export interface IWalrClientProjectsClient {

    getProjects(query: GetWalrProjectsQuery): Promise<WalrProjectsDto[]>;

    getDatasetsByProjectID(projectId: string | null): Promise<WalrDatasetDto[]>;
}

export class WalrClientProjectsClient extends BaseClient implements IWalrClientProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProjects(query: GetWalrProjectsQuery): Promise<WalrProjectsDto[]> {
        let url_ = this.baseUrl + "/shared-api/walrclientprojects/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjects(_response));
        });
    }

    protected processGetProjects(response: Response): Promise<WalrProjectsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WalrProjectsDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalrProjectsDto[]>(null as any);
    }

    getDatasetsByProjectID(projectId: string | null): Promise<WalrDatasetDto[]> {
        let url_ = this.baseUrl + "/shared-api/walrclientprojects/{projectId}/datasets";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatasetsByProjectID(_response));
        });
    }

    protected processGetDatasetsByProjectID(response: Response): Promise<WalrDatasetDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WalrDatasetDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalrDatasetDto[]>(null as any);
    }
}

export interface IWorkdayProjectsClient {

    getClients(): Promise<ClientDto[]>;

    getProjects(query: GetWorkdayProjectsQuery): Promise<PaginatedDtoOfWorkdayProjectsDto>;
}

export class WorkdayProjectsClient extends BaseClient implements IWorkdayProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getClients(): Promise<ClientDto[]> {
        let url_ = this.baseUrl + "/shared-api/workdayprojects/clients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClients(_response));
        });
    }

    protected processGetClients(response: Response): Promise<ClientDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto[]>(null as any);
    }

    getProjects(query: GetWorkdayProjectsQuery): Promise<PaginatedDtoOfWorkdayProjectsDto> {
        let url_ = this.baseUrl + "/shared-api/workdayprojects/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjects(_response));
        });
    }

    protected processGetProjects(response: Response): Promise<PaginatedDtoOfWorkdayProjectsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedDtoOfWorkdayProjectsDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedDtoOfWorkdayProjectsDto>(null as any);
    }
}

export interface CreateAccessDeniedEmailNotificationCommand {
    cookies: string[];
    userEmail: string;
    appName: string;
}

export interface CreateExceptionEmailNotificationCommand {
    title: string;
    environment?: string | undefined;
    additionalProps?: { [key: string]: string; } | undefined;
}

export interface CreateCustomEmailNotificationCommand {
    title: string;
    body?: string | undefined;
    additionalProps?: { [key: string]: string; } | undefined;
    environment?: string | undefined;
}

export interface EncodingVersionDto {
    versionId: string;
    versionDate: string;
    projectId: string;
    availableFiles: string[];
}

export interface ErrorResponse {
    errorMessage?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;
}

export interface ApiErrorResponse extends ErrorResponse {
    request: string;
    response: string;
    url?: string | undefined;
}

export interface EncodingTriggeredHistoryDto {
    token: string;
    status: EncodingTriggeringStatuses;
    createdAt: string;
    finishedAt?: string;
    errorMessage?: string | undefined;
    useDatalakeApi: boolean;
    isStacked: boolean;
}

export enum EncodingTriggeringStatuses {
    InProgress = "InProgress",
    Complete = "Complete",
    Failed = "Failed",
    Unknown = "Unknown",
}

export interface UpdateEncodingTriggeredHistoryCommand {
    token: string;
    status: EncodingTriggeringStatuses;
    errorMessage?: string | undefined;
}

export interface AddEncodingTriggeredHistoryCommand {
    projectId?: string | undefined;
    token?: string | undefined;
    message?: string | undefined;
    useDataLakeApi?: boolean;
    isStacked?: boolean;
}

export interface TriggeredEncodingStatusDto {
    status: EncodingTriggeringStatuses;
    stage?: string | undefined;
    message?: string | undefined;
    lastUpdateReceived?: string | undefined;
    usedDataLakeApi?: boolean;
    isStacked?: boolean;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };
}

export enum ChangeTypes {
    Changed = "Changed",
    Added = "Added",
    Deleted = "Deleted",
}

export interface DownloadFileByUrlCommand {
    url: string;
    fileName: string;
}

export interface ShortProjectDto {
    originProjectId: string;
    name: string;
    originSource: string;
}

export interface WalrProjectsDto {
    id: string;
    name: string;
    description: string;
    type: string;
    createdAt?: string | undefined;
    isShared?: boolean;
    isDeleted?: boolean;
}

export interface GetWalrProjectsQuery {
}

/** Dataset from Walr */
export interface WalrDatasetDto {
    createdById?: string | undefined;
    createdByName?: string | undefined;
    createdByToolId?: string | undefined;
    createdUtc?: string | undefined;
    customerId?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    interviews?: number | undefined;
    isDeleted?: boolean;
    isToolResult?: boolean;
    lastModifiedById?: string | undefined;
    lastModifiedByName?: string | undefined;
    lastModifiedUtc?: string | undefined;
    name?: string | undefined;
    projectId?: string | undefined;
    readReceipts?: ReadReceiptDto[] | undefined;
    size?: number;
    tags?: TagDto[] | undefined;
    type?: string | undefined;
}

/** Read Receipt */
export interface ReadReceiptDto {
    timeStamp?: string;
    userId?: string | undefined;
    userName?: string | undefined;
}

/** Dataset Tags */
export interface TagDto {
    id?: string | undefined;
    name?: string | undefined;
}

export interface ClientDto {
    name: string;
    id: string;
}

export interface PaginatedDtoOfWorkdayProjectsDto {
    pageData?: WorkdayProjectsDto[] | undefined;
    totalCount?: number;
    totalCountWithoutFilter?: number | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export interface WorkdayProjectsDto {
    number: string;
    name: string;
    department: string;
    clientName: string;
    projectStartDate?: string | undefined;
    projectEndDate?: string | undefined;
    polarisId?: string | undefined;
    workdayId?: string | undefined;
    salesCode?: string | undefined;
    projectRootFolderPath?: string | undefined;
    projectFolderName?: string | undefined;
    shortName?: string | undefined;
}

export interface GetWorkdayProjectsQuery {
    context: PageContextOfWorkdayProjectsFilter;
}

export interface PageContextOfWorkdayProjectsFilter {
    page?: PaginatedQuery | undefined;
    filter?: WorkdayProjectsFilter | undefined;
    sortList?: SorterDescriptor[] | undefined;
}

export interface PaginatedQuery {
    pageNumber?: number;
    pageSize?: number;
}

export interface BaseFilter {
}

export interface WorkdayProjectsFilter extends BaseFilter {
    search?: string | undefined;
}

export interface SorterDescriptor {
    field?: string | undefined;
    directions?: SortDirections;
}

export enum SortDirections {
    None = "None",
    Asceding = "Asceding",
    Desceding = "Desceding",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

const INTERGTRATION_API_ERROR_CDOE = 527;
export const INTERGTRATION_API_ERROR_NOTIFICATION = "LRWApiErrorNotification";
export type IntegrationApiErrorRespponse = {
  response: string;
  request: string;
  url?: string;
  errorMessage: string;
};